import { useFormContext } from 'react-hook-form'
import { requiredFn } from 'utility/validators'
import { Field } from '../Field'
import { SectionStyled, TextareaStyled } from '../onboardingStyles'
import { ICoachProfileFormValues } from '../types'

const BIO_MAX = 1200

export const AboutSection = () => {
  const {
    register,
    watch,
    formState: { errors }
  } = useFormContext<ICoachProfileFormValues>()

  return (
    <SectionStyled id="section-about">
      <div className="section-head">
        <div className="heading-block">
          <span className="num" aria-hidden="true">
            05
          </span>
          <div>
            <h2>About</h2>
            <div className="blurb">In your own voice — this is what clients read first.</div>
          </div>
        </div>
      </div>

      <Field
        htmlFor="bio"
        label="Bio"
        required
        help="2–4 short paragraphs. Who you are, how you work, what clients can expect."
        error={errors.bio?.message}
        counter={{ current: watch('bio').length, max: BIO_MAX }}
      >
        <TextareaStyled
          id="bio"
          rows={6}
          maxLength={BIO_MAX}
          aria-invalid={!!errors.bio || undefined}
          {...register('bio', { validate: requiredFn })}
        />
      </Field>
    </SectionStyled>
  )
}
